import axios from "axios";
import { API } from "@/lib/api";

export const OWNER_TOKEN = "ptg_owner_token";
export const ownerApi = axios.create({ baseURL: `${API}/entrepreneur` });

ownerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(OWNER_TOKEN);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

ownerApi.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && !(err.config?.url || "").includes("/login")) {
    localStorage.removeItem(OWNER_TOKEN);
    if (!window.location.pathname.endsWith("/login")) window.location.assign("/entrepreneur/login");
  }
  return Promise.reject(err);
});

export const errText = (e, fb = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fb;
};

export const inr = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;
export const monthLabel = (m) => {
  if (!m) return "";
  const [y, mo] = m.split("-").map(Number);
  return new Date(y, mo - 1, 1).toLocaleString("en-IN", { month: "short", year: "numeric" });
};
